import { format, isValid } from 'date-fns';
import { enUS, ru } from 'date-fns/locale';
import { useI18n } from 'vue-i18n';
import { capitalizeFirstLetter } from '@ui/utils/string';

export function formatDateByLang(date: Date | string | unknown, formatStr: string = 'dd MMMM yyyy', locale?: string) {
  if (!date) return '';
  return format(date, formatStr, { locale: locale === 'ru' ? ru : enUS });
}

export function formatDate(date: Date | string | unknown, formatStr: string = 'dd MMMM yyyy', i18n = useI18n()) {
  return formatDateByLang(date, formatStr, i18n.locale.value);
}

export function getMonthName(date: Date): string {
  return capitalizeFirstLetter(formatDate(date, 'LLLL'));
}

export function getWeekdayName(date: Date): string {
  return formatDate(date, 'EEEEEE');
}

function getTimeFormat(is12HourFormat?: boolean) {
  return is12HourFormat ? 'hh:mm a' : 'HH:mm';
}

export function formatTimeTemplate(time: Date, is12HourFormat?: boolean) {
  return format(time, getTimeFormat(is12HourFormat));
}

export const isDateValid = isValid;
